export const FULL_PAYMENT_DEP_KEY = '__unit_paid_100__';
export const BUC_DEP_KEY = '__building_buc_received__';
export const PRE_BUC_DEP_KEY = '__building_buc_pending__';

export const PRE_DEED_STEP_KEYS = new Set([
  'send_deed_package',
  'upload_deed_draft',
  'verify_deed_draft',
  'request_deed_charges',
  'deed_charges_collected',
  'customer_signed_deed',
  'advocate_registered_deed',
]);

export const hasRegisteredDeedEvidence = (booking: any, documents: Record<string, any>): boolean =>
  !!(
    booking?.sale_deed_date || booking?.saleDeedDate ||
    booking?.sale_deed_number || booking?.saleDeedNumber ||
    documents?.sale_deed?.files?.length || documents?.sale_deed_upload?.files?.length ||
    documents?.sale_deed_signed?.files?.length
  );

export const fullPaymentReceived = (unitAmount: unknown, received: unknown): boolean => {
  const price = Number(unitAmount);
  const paid = Number(received);
  return Number.isFinite(price) && price > 0 && Number.isFinite(paid) && paid >= price;
};

export const nearFullPayment = (unitAmount: unknown, received: unknown): boolean => {
  const price = Number(unitAmount);
  const paid = Number(received);
  return Number.isFinite(price) && price > 0 && Number.isFinite(paid) && paid >= price * 0.9 && paid < price;
};

export const buildingBucReceived = (project: any, unit: any): boolean => {
  const receivedAt = String(project?.bucReceivedAt || '').trim();
  if (!receivedAt) return false;
  const covered = Array.isArray(project?.bucReceivedBuildingNos)
    ? project.bucReceivedBuildingNos.map((value: unknown) => String(value || '').trim().toLowerCase()).filter(Boolean)
    : [];
  if (!covered.length) return true;
  const building = String(unit?.buildingNo || unit?.building_no || '').trim().toLowerCase();
  return !!building && covered.includes(building);
};
